export const actions = {
  IsLoading({ commit }, loadingStatus) {
    commit("MutationSetIsLoadingStatus", loadingStatus);
  },
};
